module.exports = __webpack_public_path__ + "static/media/img_and_enable_kbd.fb3bb326.png";